var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceActiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21876 0.789062H19.7188V3.28907H25.9688V30.7891H0.96875V3.28907H7.21876V0.789062ZM7.21876 5.78907H3.46875V28.2891H23.4688V5.78907H19.7188V9.53907H7.21876V5.78907ZM9.71876 3.28907V7.03907H17.2188V3.28907H9.71876ZM20.6027 15.4229L12.2188 23.8068L7.58487 19.1729L9.35264 17.4052L12.2188 20.2713L18.8349 13.6552L20.6027 15.4229Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceActiveIcon);
export default __webpack_public_path__ + "static/media/ComplianceActiveIcon.f279e05e65082ccd93c907f321a10455.svg";
export { ForwardRef as ReactComponent };